import Vue from 'vue'
import Vuex from 'vuex'
import {Toast} from "vant";

const bus = new Vue()

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    taskId: '',
    componentsList: [],
    controlIndex: 0,
    backUrl: '',
    sceneList: [],
    progranList: {},
    topTitle: '首页',
    topBackIconShow: false,
    parentPage: '',
    dels: [],
    width: 1920,
    height: 1080,
    scId: "",
    previewPages: {
      setting: {
        bjSwitch: true,  // 是否开启背景音乐
        loopPlay: true,  // 背景音乐是否循环播放
        autoPlay: true,  // 背景音乐是否自动播放
        musicName: "", // 背景音乐名称
        musicUrl: "", // 背景音乐名称
        PlaySpeed: 3000,  // 页面停留时间
        speed: 3000,  // 页面动画时间
        pageAnimation: "slide", // 页面动画
        autoPage: true, // 自动翻页
        direction: 'vertical', // 切换方向
      },
      pageList: [{
        pageBg: "",
        node: []
      }]
    }, //预览的
    pageIndex: 0
  },
  getters: {},
  mutations: {
    reSetTaskId(state, n) {
      state.taskId = n
    },
  },
  actions: {
    addControl({state}, data) {
      for (let i = 0; i < state.componentsList.length; i++) {
        if (data === 'hdmin' && state.componentsList[i].coType === 'hdmin') {
          Toast('HDMI控件只能添加一个')
          return
        }
      }

      state.componentsList.push({
        infoX: '0',
        infoY: '0',
        infoWidth: '500',
        infoHeight: '500',
        coActionType: '',
        coHeight: '600',
        coLeftPosition: '0',
        coLinkAction: '',
        coPsId: '1',
        coRightPosition: '0',
        coScId: '',
        coScreenProtectTime: '10',
        coState: '1',
        coType: data,
        coWidth: '600',
        id: function f() {
          const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't']
          let str = ''
          for (let i = 0; i < 12; i++) {
            str += arr[Math.floor(Math.random() * arr.length)]
          }
          return str
        }(),
        txList: [{
          id: '',
          taBgColor: '#00000000',
          taColor: '#666666',
          taContent: '',
          taAlignment: 5,
          taFontSize: '16',
          taMove: '1',
          taMoveSpeed: '1',
        }],
        mpList: [],
      })
    },
    addImages({state}, data) {
      data.map(res => {
        state.componentsList[state.controlIndex].mpList.push({
          cartoon: '1',
          cmId: '',
          mid: res.mtId,
          playParam: '10',
          size: res.mtSize,
          sort: 0,
          type: '3',
          url: res.screenshotUrl,
          volume: '70',
        })
      })
    },
    addVideos({state}, data) {
      data.map(res => {
        state.componentsList[state.controlIndex].mpList.push({
          cartoon: '1',
          cmId: '',
          mid: res.mtId,
          playParam: '10',
          size: res.mtSize,
          sort: 0,
          type: '3',
          viewUrl: res.videoViewUrl,
          volume: '70',
        })
      })
    },
    addSubtitle({state}, data) {
      state.componentsList[state.controlIndex].txList[0].taContent = data.data
    },
    emptyCanvns({state}) {
      state.backUrl = ''
      state.componentsList = []
    },
    addBackground({state}, data) {
      state.backUrl = bus.upFileUrl + data.url
      state.sceneList.scBackImg = data.url
      state.sceneList.scBackimgSize = data.mtSize
      state.sceneList.scBackImgId = data.mtId
    },
    //修改头部标题
    changeTopTitle({state}, data) {
      state.topTitle = data
    },
    //设置父级页面，用于返回操作
    setParentPage({state}, data) {
      state.parentPage = data
    },
    //设置头部返回icon显示
    changeTopIconStatus({state}, data) {
      state.topBackIconShow = data
    },

  },
  modules: {},
})
